export interface ApInvoiceSplitGroupDraft {
  document_ids: string[];
  vendor_invoice_number: string;
  invoice_date: string;
  mfr_invoice_number: string;
  total_cost: string;
  remove_duplicate?: boolean;
}

export function blankApInvoiceSplitGroup(): ApInvoiceSplitGroupDraft {
  return {
    document_ids: [],
    vendor_invoice_number: "",
    invoice_date: "",
    mfr_invoice_number: "",
    total_cost: "0",
  };
}

export function apInvoiceSplitGroupIndexForDocument(
  groups: ApInvoiceSplitGroupDraft[],
  documentId: string,
): number | null {
  const index = groups.findIndex((group) => group.document_ids.includes(documentId));
  return index >= 0 ? index : null;
}

/** Move one attachment to another group, a new group, or out of every group. */
export function moveApInvoiceSplitDocument(
  groups: ApInvoiceSplitGroupDraft[],
  documentId: string,
  target: number | "new" | "none",
): ApInvoiceSplitGroupDraft[] {
  const stripped = groups.map((group) => ({
    ...group,
    document_ids: group.document_ids.filter((id) => id !== documentId),
  }));
  if (target === "none") {
    return stripped;
  }
  if (target === "new") {
    return [...stripped, { ...blankApInvoiceSplitGroup(), document_ids: [documentId] }];
  }
  if (!Number.isInteger(target) || target < 0 || target >= stripped.length) {
    return stripped;
  }
  return stripped.map((group, index) =>
    index === target ? { ...group, document_ids: [...group.document_ids, documentId] } : group,
  );
}

export function addApInvoiceSplitGroup(groups: ApInvoiceSplitGroupDraft[]): ApInvoiceSplitGroupDraft[] {
  return [...groups, blankApInvoiceSplitGroup()];
}

/** Drop a group. Its attachments are left unassigned. */
export function removeApInvoiceSplitGroup(
  groups: ApInvoiceSplitGroupDraft[],
  index: number,
): ApInvoiceSplitGroupDraft[] {
  if (groups.length <= 1) {
    return groups;
  }
  return groups.filter((_, groupIndex) => groupIndex !== index);
}
